import { createSelector } from 'reselect'
import { pagesSelector } from '../selectors'

export const industryAndCompetitorComparisonPageSelector = createSelector(
  pagesSelector,
  pages => pages.industryAndCompetitorComparison
)
